__turbopack_context__.v({
  "change_station_button": "ConfirmStationPopup-module-scss-module__cTsY6q__change_station_button",
  "confirm_station_name": "ConfirmStationPopup-module-scss-module__cTsY6q__confirm_station_name",
  "confirm_station_popup": "ConfirmStationPopup-module-scss-module__cTsY6q__confirm_station_popup",
  "vanish": "ConfirmStationPopup-module-scss-module__cTsY6q__vanish",
});
